import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: "100%",
    height: "100%",
  },
  header: {
    paddingBottom: 0,
  },
  content: {
    paddingTop: 0,
    display: "flex",
    flexDirection: "column",
    maxHeight: 310,
    overflowY: "scroll",
    "& > *": {
      margin: theme.spacing(1),
      width: "35ch",
    },
  },
  checkbox: {
    padding: 2,
  },
  formLabel: {
    marginLeft: 0,
  },
}));

export interface Props {
  setUserLanguage?: (language: string) => void;
  user?: {
    id: string;
    email: string;
    facilityId: string;
    organisationId: string;
    language: string;
    roleName: string;
  };
}

export const UserPanel: FC<Props> = ({ user, setUserLanguage }) => {
  const classes = useStyles();

  return (
    <Card className={classes.wrapper} elevation={2}>
      <CardHeader title="User" className={classes.header} />
      <CardContent className={classes.content}>
        <FormControl>
          <InputLabel htmlFor="language-native-simple">{"Language"}</InputLabel>
          <Select
            native
            value={user?.language}
            onChange={(e) => setUserLanguage?.(e.target.value as string)}
            inputProps={{
              name: "Language",
              id: "language-native-simple",
            }}
          >
            <option value="en">{"en"}</option>
            <option value="te-st">{"te-st"}</option>
            <option value="fr">{"fr"}</option>
            <option value="es-mx">{"es-mx"}</option>
          </Select>
        </FormControl>
        <TextField
          label="Email"
          value={user?.email ?? ""}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Role"
          value={user?.roleName ?? ""}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="User ID"
          value={user?.id ?? ""}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Facility ID"
          value={user?.facilityId ?? ""}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Organisation ID"
          value={user?.organisationId ?? ""}
          InputProps={{ readOnly: true }}
        />
      </CardContent>
    </Card>
  );
};
